import { render, staticRenderFns } from "./AnnexSelect.vue?vue&type=template&id=52e6f3cc&"
import script from "./AnnexSelect.vue?vue&type=script&lang=js&"
export * from "./AnnexSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports